import React, { memo, useState } from "react";
import { Modal, ModalHeader, ModalBody, Col, Row } from "reactstrap";
import { Tabs } from "antd";
import DailyTab from "./Tabs/Line/DailyChart";
import GraphicalTab from "./Tabs/Line/GraphicalTab";
import EventsTab from "./Tabs/Line/EventsTab";
import ChartComponentLine from "./Tabs/Line/ChartComponent";

import LineModalHeader from "./LineModalHeader";
import { LanguageRounded } from "@material-ui/icons";
import LineLastDataTab from "./Tabs/Line/LastDataTab";

const { TabPane } = Tabs;



const ModalLine = ({
  lang_choiced,
  showModal,
  setShowModal,
  setDateHOC,
  dateHOC,
  Gateway_id,
  optimizers,
  Last_Productions,
  serial_number,
  gateway,
  active_balancer

}) => {
  const optimizers_id = optimizers.length>0?optimizers.map(opt => opt.PO_id):[]
  // console.log(optimizers ,optimizers_id, "is optimizers" )
 

  return (
    <Modal
      style={{ minWidth: "90%" }}
      isOpen={showModal}
      toggle={() => {
        setShowModal(false);
      }}
    >
      {/* {loading ? (
        <Loader />
      ) : (
        <> */}
          <ModalHeader toggle={() => setShowModal(false)}>
            {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.title}
            <span className="text-muted ml-2 mr-2 text-sm-center">
              ({serial_number?serial_number:"-"})
            </span>
          </ModalHeader>
          <LineModalHeader gateway={gateway} lang_choiced={lang_choiced} Gateway_id={Gateway_id}/>
          <ModalBody>
            <Tabs defaultActiveKey="1" type="card">
              <TabPane
                tab={lang_choiced.pages.byPanel.PanelGroup.Line.Modal.tableTab.title}
                key={"1"}
              >
                <LineLastDataTab active_balancer={active_balancer} Last_Productions={Last_Productions}/>
              </TabPane>
              <TabPane
                tab={lang_choiced.pages.byPanel.PanelGroup.Line.Modal.chartTab.title}
                key={"2"}
              >
                <ChartComponentLine
                  setDateHOC={(e) => setDateHOC(e)}
                  dateHOC={dateHOC}
                  Gateway_id={Gateway_id}
                />
              </TabPane>

              {/* <TabPane
            tab={lang_choiced.components.ByPanel.Panels.ModalPanel.page2}
            key="2"
          >
            <GraphicalTab powerOptimizer={powerOptimizer} sliderChartData={sliderChartData} setDateHOC={date=>setDateHOC(date)} dateHOC={dateHOC}/>
          </TabPane> */}
              <TabPane
                tab={lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.title}
                key="3"
              >
                <EventsTab
                  dateHOC={dateHOC}
                  optimizers_id={optimizers_id}
                  Gateway_id={Gateway_id}
                  optimizers={optimizers}
                  // powerOptimizer={powerOptimizer}
                  // events={events}

                  // count={count}
                />
              </TabPane>
            </Tabs>
          </ModalBody>
        {/* </>
      )} */}
    </Modal>
  );
};

export default memo(ModalLine);
